module.exports = __webpack_public_path__ + "img/241.3d05b508.png";